Collection = require('./collection')
Model = require('./Model').default
Stereotype = require('./Stereotype')

module.exports = class Stereotypes extends Collection
    model: Stereotype

    populate: (data, test)=>
        @all = new Collection(data, {model: @model})
        @reset(_.filter(data, test))
        @inflateRelationships()

    inflateRelationships: ()=>
        # loop over the data.stereotypes and pass each one to inflateRelationships
        @.each (type) =>
            @inflateRelationship type.get('fields')

    inflateRelationship: (fields) =>
        # loop over the fields and see if any need to be inflated
        fields.each (field)=>
            # fields with type 'to-one' or 'to-many' need to be inflated
            if field.get('type') == 'to-one' || field.get('type') == 'to-many'
                # Use the key from the field to lookup a stereotype from the list
                @all.where( key: field.get('otherStereotype')).forEach (relType)->
                    # set the 'values' key of our field to a collection of
                    # fields from the related stereotype
                    field.set( 'name', relType.get('name') )
                    field.set( 'value', relType.get('fields') )



// WEBPACK FOOTER //
// ./app/models/Stereotypes.coffee